:host {
  display: block;
}

h1 {
  font-family:'Lato';
  font-weight:'regular';
  line-height:120%;
  font-size:101px;
  letter-spacing:0.5;
  text-decoration:none;
}
